<template>
  <div class="integralMall">
    <top-title :name="titleName" style="min-width: 980px"></top-title>
    <div class="content">
      <!-- 头部导航切换 -->
      <div class="navTab" v-show="navTabIsShow">
        <span class="tab" :class="{ active: tabActive == 1 }" @click="tabActive = 1">积分礼品</span>
        <span class="tab" :class="{ active: tabActive == 2 }" @click="tabActive = 2">礼品列表</span>
        <span class="tab" :class="{ active: tabActive == 3 }" @click="tabActive = 3">兑换记录</span>
      </div>

      <!-- 积分礼品 -->
      <points-gift v-show="tabActive == 1" @navTabChange="navTabChange($event)"></points-gift>
      <!-- 礼品列表 -->
      <gift-list v-show="tabActive == 2"></gift-list>
      <!-- 兑换记录 -->
      <exchange-records v-if="tabActive == 3"></exchange-records>
    </div>
  </div>
</template>

<script>
import pointsGift from "./points_gift"; //积分礼品
import giftList from "./gift_list"; // 礼品列表
import exchangeRecords from "./exchange_records"; //兑换记录
import topTitle from "../../components/top-title";

export default {
  components: {
    topTitle,
    pointsGift,
    giftList,
    exchangeRecords,
  },
  data() {
    return {
      // 导航选中
      titleName: "互动商城",
      tabActive: 1,
      // 导航是否隐藏
      navTabIsShow: true,
    };
  },
  mounted() {
    if (this.$route.query.tabAct == 3) {
      this.tabActive = 2;
    }
  },
  methods: {
    navTabChange(flag) {
      this.titleName = "互动商城";
      this.navTabIsShow = flag;
    },
  },
};
</script>

<style scoped lang="scss">
.integralMall {
  box-sizing: border-box;
  padding: 10px 20px 30px;
  min-width: 1080px;
  .content {
    min-height: 880px;
    background-color: #fff;
    // box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    .navTab {
      display: flex;
      align-items: center;
      box-sizing: border-box;
      padding: 0 20px;
      position: relative;
      height: 50px;
      font-size: 14px;
      color: #666;
      border-bottom: 1px solid #f6f6f6;
      span {
        height: 50px;
        line-height: 50px;
        position: relative;
        padding: 0 11px;
        cursor: pointer;
        transition: all 0.2s;
      }
      .active {
        color: #fe4d45;
        &::before {
          content: "";
          position: absolute;
          left: 50%;
          bottom: 0;
          transform: translateX(-50%);
          width: 80%;
          height: 2px;
          background-color: #fe4d45;
          transition: all 0.2s;
          animation: opation 0.2s;
        }
        @keyframes opation {
          0% {
            opacity: 0;
          }
          100% {
            opacity: 100%;
          }
        }
      }
    }
  }
}
</style>
